import { Box, Button, Modal, Pagination, Typography } from "@mui/material";
import AutoCompleteAddress from "./auto-complete-address";
import { useEffect, useState } from "react";
import { filters as defaultFilters, formatFilters } from "./utils";
import Input from "../inputs";
import { cloneDeep, find, get, identity } from "lodash";

import API_CONSTRUCTOR from "../../models/api-model";
import PropertyAPIs from "../../models/property";
import { useNavigate } from "react-router-dom";
import { COLORS } from "../../utils/colors";
const apiModel = API_CONSTRUCTOR("https://api.propertyreach.com");
const propertyApi = new PropertyAPIs(apiModel);

const PAGE_SIZE = 25;

export const PropertySearch = ({
  onChange = identity,
  onPropertySelectFromSearch,
  setIsLoadingProperties = identity,
}) => {
  const [openFilter, setOpenFilter] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setTotalPage] = useState(0);

  const [filters, setFilters] = useState(defaultFilters);
  const [address, setAddress] = useState(null);
  const navigate = useNavigate();

  const handleAddressChange = (address) => {
    setAddress(address);
  };

  const handleFilterInput = (key) => (event) => {
    const clonedFilters = cloneDeep(filters);
    const filter = find(clonedFilters, { key });
    const value = get(event, ["target", "value"], undefined);
    filter.value = value;

    setFilters(clonedFilters);
  };

  const handleClearFilters = () => {
    const newFilters = cloneDeep(defaultFilters);
    setFilters(newFilters);
  };

  const handlePagination = (_, pageNumber) => {
    setPageNumber(pageNumber);
  };

  useEffect(() => {
    if (address) {
      const { propertyId = "" } = address;
      if (propertyId) {
        if (onPropertySelectFromSearch) {
          propertyApi
            .getPropertyDetails(propertyId)
            .then((result) => {
              const property = get(result, "property", null);
              const meta = get(result, "meta", {});
              if (property) {
                onPropertySelectFromSearch(property);
              } else {
                onPropertySelectFromSearch({ error: meta.message });
              }
            })
            .catch((error) => {
              onPropertySelectFromSearch({
                error: "Erorr fetching details for the property ",
              });
              console.error("Error fetching property details:", error);
            });
        } else {
          navigate(`/property/${propertyId}`);
        }
      } else {
        setIsLoadingProperties(true);
        const formattedFilters = formatFilters(filters);
        setTotalPage(0);

        propertyApi
          .getProperties({
            filter: formattedFilters,
            target: address,
            options: { offset: PAGE_SIZE * (pageNumber - 1), limit: PAGE_SIZE },
          })
          .then((result) => {
            const properties = get(result, ["properties"], []);
            const meta = get(result, "meta", {});
            onChange(properties);

            const { status } = meta;
            if (status === 200) {
              const { resultCount = 0 } = meta;
              const totalPage = Math.ceil(resultCount / PAGE_SIZE);
              setTotalPage(totalPage);
            }
          })
          .finally(() => {
            setIsLoadingProperties(false);
          });
      }
    }
  }, [address, pageNumber]);

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          marginBottom: 2,
          width: "100%",
        }}
      >
        <AutoCompleteAddress
          onPropertySelectFromSearch={onPropertySelectFromSearch}
          onChange={handleAddressChange}
        />
        <Button
          onClick={() => setOpenFilter(true)}
          variant="contained"
          style={{ backgroundColor: COLORS.SURFACE_1 }}
        >
          Filters
        </Button>
      </Box>
      {totalPage ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            maxWidth: 1240,
            marginTop: 4,
            marginBottom: 4,
          }}
        >
          <Pagination
            onChange={handlePagination}
            page={pageNumber}
            count={totalPage}
            variant="outlined"
            shape="rounded"
            color={COLORS.SURFACE_1}
          />
        </Box>
      ) : null}
      <Modal open={openFilter} onClose={() => setOpenFilter(false)}>
        <Box
          sx={{
            ...styles.modal,
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Box>
            <Typography variant="h6" component="h2">
              Filters
            </Typography>
          </Box>

          <Box sx={{ ...styles.filters, flexGrow: 1 }}>
            {filters.map((filter) => {
              const { key, ...rest } = filter;
              return (
                <Box width={"30%"} key={key}>
                  <Input {...rest} onChange={handleFilterInput(key)} />
                </Box>
              );
            })}
          </Box>

          <Box
            sx={{ display: "flex", justifyContent: "flex-end", paddingTop: 2 }}
          >
            <Button
              sx={{ background: "#ff7a5b" }}
              variant="contained"
              onClick={() => setOpenFilter(false)}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

const styles = {
  modal: {
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    left: "50%",
    p: 4,
    position: "absolute",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    height: "70%",
    overflow: "auto",
  },

  filters: {
    display: "flex",
    flexDirection: "row",
    gap: 2,
    flexWrap: "wrap",
    width: "100%",
  },
};

export default PropertySearch;
